var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 95,
  height: 95,
  fill: "none",
  viewBox: "0 0 95 95"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  x: 35,
  fill: "url(#paint0_linear)",
  rx: 8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  y: 15,
  fill: "#330DF2",
  rx: 8
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M59 36v38h-5.429V41.429H26.43V68.57h16.285v-5.428H31.857V46.857h16.286v5.429H37.286v5.428h10.857V74H21V36z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 95,
  x2: 35,
  y1: 0,
  y2: 60,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#330DF2",
  stopOpacity: 0.65
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0F0449",
  stopOpacity: 0
})))));
export default SvgLogoinline;